exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content_logo_text[data-v-45743ec7]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:.3em 0}.content_logo_text>span[data-v-45743ec7]{margin-left:.5em;line-height:32px}", ""]);

// exports
